// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__LQVn7","title":"styles_title__TTmB9","links":"styles_links__k8kQg","link":"styles_link___GJQR","footer":"styles_footer__UEQ_A"};